import React, { useState } from "react";
import { showError, showSuccess } from "../../../utils/toastUtils";
import MpAPI from "../../../api/admin/mpApi";
import { useTranslation } from "react-i18next";

const GlobalDeleteModal = ({ table, id, onDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      setIsDeleting(true);

      const res = await MpAPI.delete({ table: table, id: id });

      if (res.code === 200) {
        showSuccess(res.message);
        document.querySelector("#danger-header-modal .btn-close").click();
        if (onDeleted) onDeleted();
      } else {
        showError(res.message);
      }
    } catch (err) {
      console.error("Delete failed:", err);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div
      id="danger-header-modal"
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="danger-header-modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header text-bg-danger border-0">
            <h4 className="modal-title text-white" id="danger-header-modalLabel">
             {t('confirm_deletion')}
            </h4>
            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <i
              className="ti ti-alert-circle"
              style={{ fontSize: "2rem", color: "#dc3545" }}
            ></i>
            <h5 className="mt-1">{t('are_you_sure')}</h5>
            <p className="text-muted mt-1">
              {t('deletion_warning')}
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel py-2"
              data-bs-dismiss="modal"
            >
              {t('close')}
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2 py-2"
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? `${t('deleting')}...` : `${t('delete')}` }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalDeleteModal;